<template>
    <transition name="errors">
        <div v-if="errors && errors.length > 0" class="show invalid-feedback">
            <div v-for="e in errors" :key="e" v-html="e"></div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "FieldMessage",
        props: {
            errors: {
                type: Array
            }
        }
    }
</script>

<style scoped lang="scss">
    .errors-enter-active, .errors-leave-active {
        transition: opacity .2s ease;
    }
    .errors-enter, .errors-leave-to {
        opacity: 0;
    }
</style>
